// icons
import eyeFill from '@iconify/icons-eva/eye-fill';
import eyeOffFill from '@iconify/icons-eva/eye-off-fill';
import { Icon } from '@iconify/react';
// formik
import { Form, FormikProvider, ErrorMessage } from 'formik';
// custom hook
import useLoginForm from './useLoginForm'
// routes
import { PATH_AUTH } from '../../../routes/paths';
import { Link as RouterLink } from 'react-router-dom';
// material
import {
    Link,
    Stack,
    Alert,
    Checkbox,
    TextField,
    Button,
    IconButton,
    InputAdornment,
    FormControlLabel
  } from '@mui/material';
import { LoadingButton } from '@mui/lab';

function LoginForm() {
  const {showPassword, onClickShowPassword, formik} = useLoginForm();
  const { errors, touched, values, isSubmitting, handleSubmit, getFieldProps } = formik;

  return (
    <FormikProvider value={formik}>
      <Form autoComplete="on" onSubmit={handleSubmit}>
        <Stack spacing={3}>
          {errors.afterSubmit && <Alert severity="error">{errors.afterSubmit}</Alert>}
          <TextField
            fullWidth
            autoComplete="username"
            type="email"
            label="Nombre de usuario"
            {...getFieldProps('username')}
            error={Boolean(touched.username && errors.username)}
            helperText={touched.username && errors.username}
          />
          <TextField
            fullWidth
            autoComplete="current-password"
            type={showPassword ? 'text' : 'password'}
            label="Contraseña"
            {...getFieldProps('password')}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton edge="end" onClick={onClickShowPassword}>
                    <Icon icon={showPassword ? eyeFill : eyeOffFill} />
                  </IconButton>
                </InputAdornment>
              )
            }}
            error={Boolean(touched.password && errors.password)}
            helperText={touched.password && errors.password}
          />
        </Stack>
        <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ my: 2 }}>
          <FormControlLabel
            control={<Checkbox {...getFieldProps('remember')} checked={values.remember} />}
            label="Recuerdame"
          />
          <Link component={RouterLink} variant="subtitle2" to={PATH_AUTH.resetPassword}>
            Olvidaste tu contraseña?
          </Link>
        </Stack>
        <LoadingButton
          fullWidth
          size="large"
          type="submit"
          variant="contained"
          loading={isSubmitting}
        >
            Continuar
        </LoadingButton> 
      </Form>
      </FormikProvider>
  )
}

export default LoginForm
  